import 'regenerator-runtime/runtime';
import { call, put, select } from 'redux-saga/effects';

import API, { methods } from '../../canvas-api';
import { handleGenericError, getSlicerState } from '../../common';
import { actions } from '../../../reducers/slicer/slicer';

export default function* setModelVisibility(action) {
  try {
    const { currentProject: projectId } = yield select(getSlicerState);
    const { modelId, visible } = action.payload;

    const response = yield call(API, {
      method: methods.POST,
      path: `projects/${projectId}/models/${modelId}`,
      body: {
        visible,
      },
    });
    if (response === null) return;

    yield put(actions.setModelVisibilitySuccess());
    yield put(actions.invalidateSlice(projectId));
    yield put(actions.updateProjectThumbnailRequest(projectId));
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
